import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Box, Modal } from '@mui/material';

import { Button } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import TextInput from '~/components/ui/TextInput';
import { COLORS } from '~/styles/colors';

type PasswordProtectedModalProps = {
  isOpen: boolean;
  onSubmit: (password: string) => void;
};

export default function PasswordProtectedModal({ isOpen, onSubmit }: PasswordProtectedModalProps) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');

  const styles = useStyles();

  return (
    <Modal
      open={isOpen}
      sx={styles.modal}
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
    >
      <Box sx={styles.container}>
        <Text variant="h2" sx={styles.title}>
          {t('basicTemplateLabels:passwordProtection.modalTitle')}
        </Text>
        <Text variant="input15" sx={styles.description}>
          {t('basicTemplateLabels:passwordProtection.modalDesc')}
        </Text>
        <TextInput
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          label={t('basicTemplateLabels:passwordProtection.inputLabel')}
          placeholder={t('basicTemplateLabels:passwordProtection.inputPlaceholder')}
        />

        <Button onClick={() => onSubmit(password)} disableRipple size="small" sx={styles.submitBtn}>
          {t('buttons:submit')}
        </Button>
      </Box>
    </Modal>
  );
}

function useStyles() {
  return {
    backdrop: css`
      background-color: #c9c8c84d;
      backdrop-filter: blur(3px);
    `,
    modal: css`
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    container: css`
      width: 100%;
      max-width: 475px;
      padding: 20px 32px 40px;
      border-radius: 20px;
      background-color: ${COLORS.white};
      display: flex;
      flex-direction: column;

      &:focus-visible {
        outline: none;
      }
    `,
    title: css`
      cursor: initial;
      text-align: center;
      margin-bottom: 24px;
    `,
    description: css`
      cursor: initial;
      text-align: center;
      margin-bottom: 24px;
    `,
    submitBtn: css`
      margin-top: 24px;
      height: 40px;
      padding: 4px 20px !important;
    `,
  };
}
